/* eslint-disable no-undef */
import * as pkijs from 'pkijs';

const dgstmap = {
  '1.3.14.3.2.26': 'SHA-1',
  '2.16.840.1.101.3.4.2.1': 'SHA-256',
  '2.16.840.1.101.3.4.2.2': 'SHA-384',
  '2.16.840.1.101.3.4.2.3': 'SHA-512'
};

const rdnmap = {
  '2.5.4.6': 'C',
  '2.5.4.10': 'O',
  '2.5.4.11': 'OU',
  '2.5.4.3': 'CN',
  '2.5.4.7': 'L',
  '2.5.4.8': 'ST',
  '2.5.4.12': 'T',
  '2.5.4.42': 'GN',
  '2.5.4.43': 'I',
  '2.5.4.4': 'SN',
  '1.2.840.113549.1.9.1': 'E-mail',
  '2.5.4.97': 'organizationIdentifier'
};

const rsamap = {
  '1.2.840.113549.1.1.': 'sha-1WithRSAEncryption',
  '1.2.840.113549.1.1.14': 'sha-224WithRSAEncryption',
  '1.2.840.113549.1.1.11': 'sha-256WithRSAEncryption',
  '1.2.840.113549.1.1.12': 'sha-384WithRSAEncryption',
  '1.2.840.113549.1.1.13': 'sha-512WithRSAEncryption'
};

export const parseTSR = (tsr) => {
  const tspRespSimpl = pkijs.TimeStampResp.fromBER(Buffer.from(tsr, 'base64'));

  const signedSimpl = new pkijs.SignedData({ schema: tspRespSimpl.timeStampToken.content });

  const tstInfoSimpl = pkijs.TSTInfo.fromBER(signedSimpl.encapContentInfo.eContent.valueBlock.valueHexView);

  const hashAlgorithm = dgstmap[tstInfoSimpl.messageImprint.hashAlgorithm.algorithmId] || tstInfoSimpl.messageImprint.hashAlgorithm.algorithmId;

  const seconds = tstInfoSimpl.accuracy.seconds || 0;
  const millis = (tstInfoSimpl.accuracy.millis || 0) * 1000;
  const micros = (tstInfoSimpl.accuracy.micros || 0) + millis;
  const accuracy = `${seconds}.${micros.toString().padStart(4, '0')}`;

  const certificates = signedSimpl.certificates.map(cert => ({
    issuerDN: cert.issuer.typesAndValues.map(({ type, value }) => {
      const typeval = rdnmap[type] || type;
      const subjval = value.valueBlock.value;
      return `${typeval}=${subjval}`;
    }),
    subjectDN: cert.subject.typesAndValues.map(({ type, value }) => {
      const typeval = rdnmap[type] || type;
      const subjval = value.valueBlock.value;
      return `${typeval}=${subjval}`;
    }),
    serialNumber: cert.serialNumber.toJSON().valueBlock.valueHex,
    notBefore: cert.notBefore.value.toString(),
    notAfter: cert.notAfter.value.toString(),
    signatureAlgorithm: rsamap[cert.signatureAlgorithm.algorithmId] || cert.signatureAlgorithm.algorithmId,
    publickey: cert.subjectPublicKeyInfo.toString()
  }));

  const pki = {
    status: pkijs.PKIStatus[tspRespSimpl.status.status],
    policy: tstInfoSimpl.policy,
    algo: hashAlgorithm,
    data: Buffer.from(tstInfoSimpl.messageImprint.hashedMessage.valueBlock.valueHexView).toString('hex'),
    serial: Buffer.from(tstInfoSimpl.serialNumber.valueBlock.valueHexView).toString('hex'),
    time: tstInfoSimpl.genTime.toString(),
    accuracy,
    nonce: Buffer.from(tstInfoSimpl.nonce.valueBlock.valueHexView).toString('hex'),
    certificates
  };
  return pki;
};
